<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="4">
              <v-select
                :items="exams"
                v-model="exam"
                label="Kỳ kiểm tra"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="4">
              <AutocompleteGrade
                return-object
                v-model="grade"
                item-text="title"
                item-value="id"
                label="Khối"
                required
                hide-details
                dense
                outlined
                @change="gradeChanged"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam || !grade"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteGrade from '../../components/basic/input/AutocompleteGrade.vue'

export default {
  props: {},
  data() {
    return {
      exam: null,
      grade: null,
      exams: []
    }
  },
  async mounted() {
    await this.getExams()
  },
  components: {
    AutocompleteGrade
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('roomSubject', ['fetchRoomSubjects']),
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('teacherExam', ['fetchTeacherExams']),
    onFilterChanged() {
      const params = {
        examId: this.exam.id,
        gradeId: this.grade ? this.grade._id : ''
      }

      this.$emit('onFilterChanged', params, this.exam)
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({})
      this.$loading.active = false
    },
    gradeChanged(grade) {
      this.grade = grade
    }
  }
}
</script>
